import React, { FC } from 'react'
import { BasicStatsItem } from './index.styles'
import { Text } from '../text.component'
import { useTranslation } from 'react-i18next'
import { ExpandCard } from '../../assets/icons'

const link = 'https://app.powerbi.com/view?r=eyJrIjoiNWE2ZTQ3NzEtODJiNi00YTlhLWExOGMtYWVkNjA2OTc5ZTFhIiwidCI6ImU2MjQzNTFhLWViZGItNDUwMi1hNGEzLTRiZWI3OTYxODBlZiIsImMiOjl9'

interface IProps {
  handleFullScreen: (obj: any) => void;
}

const Provision: FC<IProps> = ({ handleFullScreen }) => {
  const { t } = useTranslation()
  return (
    <BasicStatsItem >
      <div className="title with-icon">
        <div className="left">
          <Text color='var(--primary-color)'

            fontWeight={500} fontSize='0.875rem'>{t(`provision.title`)}</Text>
        </div>
        <div className="right">
          <span className='unit-container' >
            <ExpandCard onClick={() => handleFullScreen && handleFullScreen({ isOpen: true, type: 'Provision' })} />
          </span>
        </div>
      </div>
      <div className="body" style={{ maxHeight: '23rem', padding: 0 }} >
        <iframe style={{ borderRadius: 'inherit' }} title="Provision iframe" src={link} />
      </div>
    </BasicStatsItem>
  )
}

export default Provision